import React from "react"
import { Container } from "reactstrap"

const Header = () => (
  <section className="hero header-blue-bg py-3 py-md-5 px-2 px-lg-3">
    {/* <div className=" p-0 m-0 py-xxl-5  ps-0 ps-xl-5 ms-0 ms-xl-5"> */}
    <div className="px-2 px-lg-5 py-3 py-md-5">
      <p
        className="ff-cooper font-size-120 fw-normal text-center text-lg-start transparent-text-border d-block m-0 p-0 me-xxl-2 pt-2 pt-md-5"
        style={{ lineHeight: "0.3" }}
      >
        we are the
      </p>
      <p
        className="ff-cooper font-size-224 text-center  primary-green-text d-block m-0 p-0 lh-1 text-uppercase pt-2 d-flex justify-content-center justify-content-lg-start "
        style={{ lineHeight: "0.2" }}
      >
        Dockies
      </p>
      <p
        className="ff-proxima text-uppercase fw-bolder  text-center text-lg-end font-size-32 header-sub-text borde pt-lg-2"
        style={{
          fontStyle: "italic",
          lineHeight: "0.9",
        }}
      >
        Dad joke headquarters
      </p>
    </div>
  </section>
)

export default Header
